var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfiniti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 48,
    viewBox: "0 0 86 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43 11C27.535 11 15 16.883 15 24.148C15 30.44 24.4 35.701 36.971 36.998C37.0412 37.0053 37.112 36.9905 37.1735 36.9558C37.2349 36.921 37.2841 36.868 37.314 36.804L42.694 25.229C42.7216 25.171 42.7651 25.122 42.8195 25.0876C42.8738 25.0533 42.9367 25.0351 43.001 25.0351C43.0653 25.0351 43.1282 25.0533 43.1825 25.0876C43.2369 25.122 43.2804 25.171 43.308 25.229L48.688 36.804C48.7179 36.868 48.7671 36.921 48.8285 36.9558C48.89 36.9905 48.9608 37.0053 49.031 36.998C61.6 35.702 71 30.44 71 24.149C71 16.883 58.465 11 43 11ZM54.991 30.242L43.248 17.679C43.2162 17.6453 43.1779 17.6184 43.1353 17.6C43.0927 17.5816 43.0469 17.5721 43.0005 17.5721C42.9541 17.5721 42.9083 17.5816 42.8657 17.6C42.8231 17.6184 42.7848 17.6453 42.753 17.679L31.009 30.242C24.346 29.602 19.94 25.96 19.94 22.684C19.94 18.457 29.415 13.745 43 13.745C56.594 13.745 66.06 18.457 66.06 22.685C66.06 25.961 61.654 29.601 54.991 30.242Z",
    fill: "#F5F4F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.903 29.929L55 29.909L43.607 18.1C43.477 17.966 43.257 17.966 43.127 18.1L42 19.268L51.112 28.713C52.078 29.715 53.51 30.191 54.902 29.93L54.903 29.929Z",
    fill: "#9691A4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.671 30.842L35 36.704L37.293 36.998C37.3598 37.0048 37.427 36.9903 37.4852 36.9568C37.5433 36.9232 37.5894 36.8722 37.617 36.811L43 25L42.71 25.637C40.372 26.965 38.796 28.373 37.671 30.842Z",
    fill: "#BBB7C5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.389 11L42 11.017C56.605 11.361 68.222 17.106 68.222 24.149C68.222 30.029 60.124 35.009 48.945 36.694L48.996 36.805C49.056 36.936 49.192 37.014 49.334 36.999C61.73 35.702 71 30.44 71 24.149C71 16.883 58.64 11 43.389 11Z",
    fill: "#9691A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfiniti);
export default __webpack_public_path__ + "static/media/infiniti.33ebd6938b6a3493ba86fae1489710f3.svg";
export { ForwardRef as ReactComponent };